import React from 'react';
import css from './BrightSpan.module.scss';

interface BrightSpanProps {
  children: React.ReactNode;
  className?: string;
}

export const BrightSpan: React.FC<BrightSpanProps> = ({ children, className }) => {
  return <span className={`${css.brightSpan} ${className || ''}`}>{children}</span>;
};
